import { render, staticRenderFns } from "./HKLDocBadge.vue?vue&type=template&id=302f68f0&scoped=true&"
import script from "./HKLDocBadge.vue?vue&type=script&lang=js&"
export * from "./HKLDocBadge.vue?vue&type=script&lang=js&"
import style0 from "./HKLDocBadge.vue?vue&type=style&index=0&id=302f68f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302f68f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('302f68f0')) {
      api.createRecord('302f68f0', component.options)
    } else {
      api.reload('302f68f0', component.options)
    }
    module.hot.accept("./HKLDocBadge.vue?vue&type=template&id=302f68f0&scoped=true&", function () {
      api.rerender('302f68f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/Badge/HKLDocBadge.vue"
export default component.exports